import Vue from 'vue';
import Router from 'vue-router';
import VueMeta from 'vue-meta';
import { LAYOUTS } from '../constants';

Vue.use(Router);
Vue.use(VueMeta);

const authOrUnauth = (to, router, store) => {
	if (store.getters.isLoggedIn) {
		return LAYOUTS.APP;
	}

	return LAYOUTS.SALES;
};

/**
 * Meta values determine route-specific functionality. *Note* that if a meta value doesn't exist on the route, it will look upwards to parents for a match and take the closest parents matching meta value (if applicable)
 * Meta Route Values:
 * {String} title - the title of the page
 * {Boolean} guest - Whether or not this route is intended only for guests
 * {Boolean} app - Specifies that the user must be authenticated to view this page
 * {String} layout - The layout for this route. must be set to one of the values in the LAYOUTS constant
 * {Boolean|String} intendedOverride - a special value that indicates this page can't be redirected to after switching accounts. Bool false wil direct them to the default (dashboard), a string would be a replacement path to take htem to
 */

export default () => {
	return new Router({
		mode: 'history',
		base: process.env.BASE_URL,
		linkActiveClass: 'active',
		routes: [

			// ------------------------------------------------------------------------------------------------------ //
			/** Sales / Unauth Sections **/
			// ------------------------------------------------------------------------------------------------------ //


			{
				path: '/',
				redirect: { name: 'dashboard' },
				// meta: { guest: true, title: 'Sales Landing Page' },
				// component: () => import(/* webpackChunkName: "SalesPage" */ '@/views/sections/sales/SalesPage')
			},

			{
				path: '/login',
				name: 'login',
				meta: { guest: true, title: 'Log In' },
				component: () => import(/* webpackChunkName: "LoginPage" */ '@/views/sections/auth/LoginPage')
			},

			{
				path: '/signup',
				name: 'signup',
				meta: { guest: true, title: 'Sign Up' },
				component: () => import(/* webpackChunkName: "SignUpPage" */ '@/views/sections/auth/SignUpPage')
			},

			{
				path: '/forgot-password',
				name: 'forgot-password',
				props: true,
				meta: { guest: true, title: 'Forgot Password' },
				component: () => import(/* webpackChunkName: "ForgotPasswordPage" */ '@/views/sections/auth/ForgotPasswordPage'),
			},
			{
				path: '/password/reset/:token',
				name: 'reset-password',
				props: true,
				meta: { guest: true, title: 'Reset Password' },
				component: () => import(/* webpackChunkName: "ResetPasswordPage" */ '@/views/sections/auth/ResetPasswordPage'),
			},

			// ------------------------------------------------------------------------------------------------------ //
			/** User Invitation Section (Either Auth or Unauth Layout) **/
			// ------------------------------------------------------------------------------------------------------ //

			{
				path: '/connect/:accountId/:userId/:signature/respond',
				name: 'invitation-response',
				meta: { title: 'Invitation To Gravity Fox', layout: authOrUnauth },
				component: () => import(/* webpackChunkName: "InvitationResponsePage" */ '@/views/sections/invites/BaseInvitationResponsePage')
			},

			{
				path: '/connect/:accountId/:userId/:signature/reject',
				name: 'invitation-response-reject',
				meta: { guest: true, title: 'Rejected Invitation', layout: authOrUnauth },
				component: () => import(/* webpackChunkName: "InvitationRejectionPage" */ '@/views/sections/invites/InvitationRejectionPage')
			},

			// ------------------------------------------------------------------------------------------------------ //
			/** App Sections **/
			// ------------------------------------------------------------------------------------------------------ //

			{
				path: '/',
				meta: { app: true, layout: LAYOUTS.APP },
				component: () => import(/* webpackChunkName: "BillingPage" */ '@/views/AbstractSection'),
				children: [
					{
						path: '/dashboard',
						name: 'dashboard',
						meta: { title: 'Dashboard' },
						component: () => import(/* webpackChunkName: "DashboardPage" */ '@/views/sections/app/dashboard/DashboardPage')
					},

					/** CRUD Modules **/

					{
						path: '/module/:slug',
						// name: 'adminModule',
						meta: { intendedOverride: '/dashboard' },
						props: (route) => ({ slug: route.params.slug, route }),
						component: () => import(/* webpackChunkName: "AdminModuleRoot" */ '@/views/sections/app/modules/AdminModuleRoot'),
						children: [
							{
								path: '',
								name: 'list',
								meta: { },
								component: () => import(/* webpackChunkName: "ModuleListPage" */ '@/views/sections/app/modules/ListPage'),
							},
							{
								path: 'create',
								name: 'create',
								component: () => import(/* webpackChunkName: "ModuleCreatePage" */ '@/views/sections/app/modules/FormPage'),
							},
							{
								path: ':id/edit/:page?/:childId?',
								name: 'edit',
								meta: {  },
								component: () => import(/* webpackChunkName: "ModuleEditPage" */ '@/views/sections/app/modules/FormPage'),
							},
							{
								path: 'tags/:id',
								name: 'tags',
								meta: {  },
								component: () => import(/* webpackChunkName: "ModuleTagPage" */ '@/views/sections/app/modules/TagPage'),
							},

							{
								path: 'gallery/:rowId',
								name: 'gallery',
								meta: { },
								props: true,
								component: () => import(/* webpackChunkName: "PhotoGalleryPage" */ '@/views/sections/app/modules/gallery/GalleryPage'),
							},

							{
								path: 'file-gallery/:rowId',
								name: 'file-gallery',
								meta: { },
								props: true,
								component: () => import(/* webpackChunkName: "FileGalleryPage" */ '@/views/sections/app/modules/file-gallery/FileGalleryPage'),
							},

							// Module Filters

							{
								path: 'filters',
								name: 'module-filters-page',
								meta: { title: 'Module Filters' },
								component: () => import(/* webpackChunkName: "FiltersOverviewPage" */ '@/views/sections/app/modules/filters/FiltersOverviewPage')
							},
							{
								path: 'filters/create',
								name: 'module-filters-create-page',
								meta: { title: 'Create Module Filter' },
								component: () => import(/* webpackChunkName: "FiltersCreatePage" */ '@/views/sections/app/modules/filters/FiltersCreatePage')
							},
							{
								path: 'filters/:filterId/edit',
								name: 'module-filters-edit-page',
								meta: { title: 'Edit Module Filter' },
								component: () => import(/* webpackChunkName: "FiltersUpdatePage" */ '@/views/sections/app/modules/filters/FiltersUpdatePage')
							},
						],
					},

					// {
					// 	path: '/module/:slug/gallery/:rowId',
					// 	name: 'gallery',
					// 	meta: { },
					// 	props: true,
					// 	component: require('./pages/AdminGallery/GalleryPage').default
					// },
					//
					// {
					// 	path: '/module/:slug/file-gallery/:rowId',
					// 	name: 'file-gallery',
					// 	meta: { },
					// 	props: true,
					// 	component: require('./pages/AdminFileGallery/GalleryPage').default
					// },

					// Activity Log

					{
						path: '/activity-log',
						// redirect: { name: 'activity-overview' },
						meta: { title: 'Activity Log' },
						component: () => import(/* webpackChunkName: "ActivityLogPage" */ '@/views/AbstractSection'),
						children: [
							{
								path: '',
								name: 'activity-overview',
								component: () => import(/* webpackChunkName: "ActivityLogOverviewPage" */ '@/views/sections/app/activity-log/ActivityLogOverviewPage'),
							},
							{
								path: ':id/details',
								name: 'activity-details',
								meta: { title: 'Activity Log Details' },
								component: () => import(/* webpackChunkName: "ActivityLogDetailsPage" */ '@/views/sections/app/activity-log/ActivityLogJSONDetailsPage')
							},
							{
								path: ':id/details/json',
								name: 'activity-json-details',
								meta: { title: 'Activity Log Details' },
								component: () => import(/* webpackChunkName: "ActivityLogDetailsPage" */ '@/views/sections/app/activity-log/ActivityLogJSONDetailsPage')
							},
						],
					},

					// Inquiries Received

					{
						path: '/inquiries',
						meta: { title: 'Web Inquiries' },
						component: () => import(/* webpackChunkName: "InquiriesPage" */ '@/views/AbstractSection'),
						children: [
							{
								path: '',
								name: 'inquiries-overview',
								props: true,
								component: () => import(/* webpackChunkName: "InquiriesOverviewPage" */ '@/views/sections/app/inquiries/InquiriesOverviewPage'),
							},
							{
								path: ':id/details',
								name: 'inquiry-details',
								meta: { title: 'Web Inquiry Details' },
								props: true,
								component: () => import(/* webpackChunkName: "InquiryDetailsPage" */ '@/views/sections/app/inquiries/InquiryDetailsPage')
							},
							{
								path: ':id/details/json',
								name: 'inquiry-details-json',
								meta: { title: 'Web Inquiry Details' },
								props: true,
								component: () => import(/* webpackChunkName: "InquiryDetailsJSONPage" */ '@/views/sections/app/inquiries/InquiryDetailsJSONPage')
							},
						],
					},

					// Commerce

					{
						path: '/commerce',
						meta: { title: 'Commerce', commerce: true },
						component: () => import(/* webpackChunkName: "CommerceSection" */ '@/views/AbstractSection'),
						children: [
							{
								path: 'products',
								props: true,
								component: () => import(/* webpackChunkName: "CommerceProductsSection" */ '@/views/AbstractSection'),
								children: [
									{
										path: '',
										name: 'CommerceProductsList',
										meta: { title: 'Products' },
										component: () => import(/* webpackChunkName: "CommerceProductsListPage" */ '@/views/sections/app/commerce/products/ProductsListPage'),
									},
									{
										path: 'list', // Old-style list url rerouting
										redirect: { name: 'CommerceProductsList' },
									},
									{
										path: 'create',
										name: 'CommerceProductsCreate',
										meta: { title: 'Create Product' },
										component: () => import(/* webpackChunkName: "CommerceProductsCreatePage" */ '@/views/sections/app/commerce/products/ProductsCreatePage'),
									},
									{
										path: 'categories',
										name: 'CommerceManageCategories',
										meta: { title: 'Manage Categories' },
										component: () => import(/* webpackChunkName: "CommerceManageCategoriesPage" */ '@/views/sections/app/commerce/products/ManageCategoriesPage'),
									},
									{
										path: ':id/edit',
										name: 'CommerceProductsEdit',
										meta: { title: 'Edit Product' },
										component: () => import(/* webpackChunkName: "CommerceProductsEditPage" */ '@/views/sections/app/commerce/products/ProductsEditPage'),
									},
								]
							},
							{
								path: 'orders',
								props: true,
								component: () => import(/* webpackChunkName: "CommerceOrdersSection" */ '@/views/AbstractSection'),
								children: [
									{
										path: '',
										name: 'CommerceOrdersList',
										meta: { title: 'Orders' },
										component: () => import(/* webpackChunkName: "CommerceOrdersListPage" */ '@/views/sections/app/commerce/orders/OrdersListPage'),
									},
									{
										path: ':id/details',
										name: 'CommerceOrderDetails',
										meta: { title: 'Order Details' },
										component: () => import(/* webpackChunkName: "CommerceOrderDetailsPage" */ '@/views/sections/app/commerce/orders/OrderDetailsPage'),
									},
								]
							},
							{
								path: 'customers',
								props: true,
								component: () => import(/* webpackChunkName: "CommerceCustomersSection" */ '@/views/AbstractSection'),
								children: [
									{
										path: '',
										name: 'CommerceCustomersList',
										meta: { title: 'Customers' },
										component: () => import(/* webpackChunkName: "CommerceCustomersListPage" */ '@/views/sections/app/commerce/customers/CustomersListPage'),
									},
									{
										path: ':id/details',
										name: 'CommerceCustomerDetails',
										meta: { title: 'Customer Details' },
										component: () => import(/* webpackChunkName: "CommerceCustomerDetailsPage" */ '@/views/sections/app/commerce/customers/CustomerDetailsPage'),
									},
								]
							},
						],
					},

					{
						path: '/account',
						redirect: { name: 'accounts-overview' },
						component: () => import(/* webpackChunkName: "AccountPage" */ '@/views/AbstractSection'),
						children: [
							{
								path: ':id/switch',
								name: 'accounts-switch',
								meta: { title: 'Switch Accounts', layout: LAYOUTS.BLANK, intendedOverride: false },
								component: () => import(/* webpackChunkName: "SwitchAccountPage" */ '@/views/sections/app/account/accounts/SwitchAccountPage')
							},

							// Users

							{
								path: 'users/overview',
								name: 'users-overview',
								meta: { title: 'Users' },
								component: () => import(/* webpackChunkName: "UsersOverviewPage" */ '@/views/sections/app/account/users/UsersOverviewPage')
							},
							{
								path: 'users/create',
								name: 'users-create',
								meta: { title: 'Create Account User' },
								component: () => import(/* webpackChunkName: "UsersCreatePage" */ '@/views/sections/app/account/users/UsersCreatePage')
							},
							{
								path: 'users/:id/edit',
								name: 'users-edit',
								meta: { title: 'Edit Account User', intendedOverride: '/account' },
								component: () => import(/* webpackChunkName: "UsersUpdatePage" */ '@/views/sections/app/account/users/UsersUpdatePage')
							},
						]
					},

					{
						path: '/settings',
						redirect: { name: 'profile-page' },
						component: () => import(/* webpackChunkName: "SettingPage" */ '@/views/AbstractSection'),
						children: [
							{
								path: 'profile',
								name: 'profile-page',
								meta: { title: 'Profile' },
								component: () => import(/* webpackChunkName: "ProfilePage" */ '@/views/sections/app/settings/ProfilePage')
							},
							{
								path: 'ux',
								name: 'ux-page',
								meta: { superAdmin: true, title: 'Customize Appearance' },
								component: () => import(/* webpackChunkName: "UXPage" */ '@/views/sections/app/settings/UXPage')
							},

							// Tokens

							{
								path: 'tokens',
								name: 'tokens-page',
								meta: { title: 'Tokens' },
								component: () => import(/* webpackChunkName: "TokensOverviewPage" */ '@/views/sections/app/settings/tokens/TokensOverviewPage')
							},
							{
								path: 'tokens/create',
								name: 'tokens-create-page',
								meta: { title: 'Create Filter' },
								component: () => import(/* webpackChunkName: "TokensCreatePage" */ '@/views/sections/app/settings/tokens/TokensCreatePage')
							},
						]
					},

					// Email Verification

					{
						path: '/email-verified',
						name: 'email-verified',
						props: true,
						meta: { title: 'Email Verified' },
						component: () => import(/* webpackChunkName: "EmailVerifiedPage" */ '@/views/misc/EmailVerifiedPage'),
					},

					{
						path: '/email-verification-required',
						name: 'email-verification-required',
						props: true,
						meta: { title: 'Email Verification Required' },
						component: () => import(/* webpackChunkName: "EmailVerificationRequired" */ '@/views/misc/EmailVerificationRequired'),
					},

					// Super Admin

					{
						path: '/admin',
						redirect: { name: 'super-accounts-page' },
						meta: { superAdmin: true, intendedOverride: '/dashboard' },
						component: () => import(/* webpackChunkName: "AdminPage" */ '@/views/AbstractSection'),
						children: [
							{
								path: 'dashboard',
								name: 'super-dashboard-page',
								meta: { title: 'Super Admin Dashboard' },
								component: () => import(/* webpackChunkName: "AdminDashboardPage" */ '@/views/sections/app/admin/AdminDashboardPage')
							},
							{
								path: 'deployments',
								name: 'super-deployments-page',
								meta: { title: 'Deployments' },
								component: () => import(/* webpackChunkName: "AdminDeploymentsOverviewPage" */ '@/views/sections/app/admin/deployments/DeploymentsOverviewPage')
							},
							{
								path: 'accounts',
								name: 'super-accounts-page',
								meta: { title: 'Accounts' },
								component: () => import(/* webpackChunkName: "AdminAccountsOverviewPage" */ '@/views/sections/app/admin/accounts/AccountsOverviewPage')
							},
							{
								path: 'accounts/usage',
								name: 'super-accounts-usage-page',
								meta: { title: 'Account Usage' },
								component: () => import(/* webpackChunkName: "AdminAccountsUsageOverviewPage" */ '@/views/sections/app/admin/accounts/AccountsUsageOverviewPage')
							},
							{
								path: 'accounts/vitals',
								name: 'super-accounts-vitals-page',
								meta: { title: 'Git Repo Vitals' },
								component: () => import(/* webpackChunkName: "AdminAccountsVitalsOverviewPage" */ '@/views/sections/app/admin/accounts/AccountsVitalsOverviewPage')
							},
							{
								path: 'accounts/users',
								name: 'super-account-users-page',
								meta: { title: 'Users' },
								component: () => import(/* webpackChunkName: "AdminAccountUsersOverviewPage" */ '@/views/sections/app/admin/accounts/users/AccountUsersOverviewPage')
							},
							{
								path: 'accounts/users/:id/edit',
								name: 'super-account-users-details-page',
								meta: { title: 'Account User Details' },
								component: () => import(/* webpackChunkName: "AdminAccountUsersDetailsPage" */ '@/views/sections/app/admin/accounts/users/AccountUsersDetailsPage')
							},
							{
								path: 'accounts/create',
								name: 'super-accounts-create-page',
								meta: { title: 'Create Account' },
								component: () => import(/* webpackChunkName: "AdminAccountsCreatePage" */ '@/views/sections/app/admin/accounts/AccountsCreatePage')
							},
							{
								path: 'accounts/:accountId',
								redirect: { name: 'super-account-modules-page' },
								component: () => import(/* webpackChunkName: "AdminAccountPage" */ '@/views/AbstractSection'),
								children: [
									{
										path: 'edit',
										name: 'super-accounts-edit-page',
										meta: { title: 'Edit Account' },
										component: () => import(/* webpackChunkName: "AdminAccountsEditPage" */ '@/views/sections/app/admin/accounts/AccountsUpdatePage')
									},

									// Account Modules

									{
										path: 'modules',
										name: 'super-account-modules-page',
										meta: { title: 'Account Modules' },
										component: () => import(/* webpackChunkName: "AdminAccountsModulesPage" */ '@/views/sections/app/admin/accounts/modules/ModulesOverviewPage')
									},
									{
										path: 'modules/create',
										name: 'super-account-modules-create-page',
										meta: { title: 'Create Account Module' },
										component: () => import(/* webpackChunkName: "AdminAccountsModulesCreatePage" */ '@/views/sections/app/admin/accounts/modules/ModulesCreatePage')
									},
									{
										path: 'modules/:moduleId/edit',
										name: 'super-account-modules-edit-page',
										meta: { title: 'Edit Account Module' },
										component: () => import(/* webpackChunkName: "AdminAccountsModulesUpdatePage" */ '@/views/sections/app/admin/accounts/modules/ModulesUpdatePage')
									},

									// Webhooks

									{
										path: 'webhooks',
										name: 'super-account-webhooks-page',
										meta: { title: 'Account Webhooks' },
										component: () => import(/* webpackChunkName: "WebhooksOverviewPage" */ '@/views/sections/app/admin/accounts/webhooks/WebhooksOverviewPage')
									},
									{
										path: 'webhooks/create',
										name: 'super-account-webhooks-create-page',
										meta: { title: 'Create Account Webhook' },
										component: () => import(/* webpackChunkName: "WebhooksCreatePage" */ '@/views/sections/app/admin/accounts/webhooks/WebhooksCreatePage')
									},
									{
										path: 'webhooks/:webhookId/edit',
										name: 'super-account-webhooks-edit-page',
										meta: { title: 'Edit Account Webhook' },
										component: () => import(/* webpackChunkName: "WebhooksUpdatePage" */ '@/views/sections/app/admin/accounts/webhooks/WebhooksUpdatePage')
									},

									// Extensions

									{
										path: 'extensions',
										name: 'super-account-extensions-page',
										meta: { title: 'Account Extensions' },
										component: () => import(/* webpackChunkName: "ExtensionsOverviewPage" */ '@/views/sections/app/admin/accounts/wysiwyg-extensions/ExtensionsOverviewPage')
									},
									{
										path: 'extensions/create',
										name: 'super-account-extensions-create-page',
										meta: { title: 'Create Account Extension' },
										component: () => import(/* webpackChunkName: "ExtensionsCreatePage" */ '@/views/sections/app/admin/accounts/wysiwyg-extensions/ExtensionsCreatePage')
									},
									{
										path: 'extensions/:extensionId/edit',
										name: 'super-account-extensions-edit-page',
										meta: { title: 'Edit Account Extension' },
										component: () => import(/* webpackChunkName: "ExtensionsUpdatePage" */ '@/views/sections/app/admin/accounts/wysiwyg-extensions/ExtensionsUpdatePage')
									},

									// Triggers

									{
										path: 'triggers',
										name: 'super-account-triggers-page',
										meta: { title: 'Account Triggers' },
										component: () => import(/* webpackChunkName: "TriggersOverviewPage" */ '@/views/sections/app/admin/accounts/triggers/TriggersOverviewPage')
									},
									{
										path: 'triggers/create',
										name: 'super-account-triggers-create-page',
										meta: { title: 'Create Account Trigger' },
										component: () => import(/* webpackChunkName: "TriggersCreatePage" */ '@/views/sections/app/admin/accounts/triggers/TriggersCreatePage')
									},
									{
										path: 'triggers/:triggerId/edit',
										name: 'super-account-triggers-edit-page',
										meta: { title: 'Edit Account Trigger' },
										component: () => import(/* webpackChunkName: "TriggersUpdatePage" */ '@/views/sections/app/admin/accounts/triggers/TriggersUpdatePage')
									},

									// Module Flags

									{
										path: 'flags',
										name: 'super-account-flags-page',
										meta: { title: 'Account Flags' },
										component: () => import(/* webpackChunkName: "FlagsOverviewPage" */ '@/views/sections/app/admin/accounts/flags/FlagsOverviewPage')
									},
									{
										path: 'flags/create',
										name: 'super-account-flags-create-page',
										meta: { title: 'Create Account Flag' },
										component: () => import(/* webpackChunkName: "FlagsCreatePage" */ '@/views/sections/app/admin/accounts/flags/FlagsCreatePage')
									},
									{
										path: 'flags/:flagId/edit',
										name: 'super-account-flags-edit-page',
										meta: { title: 'Edit Account Flag' },
										component: () => import(/* webpackChunkName: "FlagsUpdatePage" */ '@/views/sections/app/admin/accounts/flags/FlagsUpdatePage')
									},

								],
							},
						],
					},
				]
			},

			/**
			 * Account Switching Wrapper -
			 */
			{
				path: '/go/:accountId',
				name: 'link-navigator',
				meta: { props: true },
				component: () => import(/* webpackChunkName: "LinkNavigator" */ '@/views/misc/LinkNavigator')
			},

			{
				path: '/*',
				redirect: { name: 'dashboard' },
			},
		]
	});
};
